import { action, makeObservable, observable } from 'mobx';
import { IRequestOptions } from '@move-frontend/utils';
import {
	Dap,
	FlightEnrichStore,
	IFlight,
	IFlightFilterParams,
	IFlightsResponse,
	RemoteDataStore,
} from '@move-frontend/dap';

// NOTE: This store was made to support the old GOAA api.
// TODO: Remove this store when new API is available.

export class FlightDetailStore<
	FlightType extends IFlight,
	EnrichableProps extends {},
> extends RemoteDataStore<
	IFlightFilterParams<FlightType>,
	IFlightsResponse<FlightType>
> {
	private _flight?: FlightType;

	private _params?: IFlightFilterParams<FlightType>;

	protected readonly flightEnrichStore: FlightEnrichStore<
		FlightType,
		EnrichableProps
	>;

	protected readonly api: Dap;

	constructor(
		flightEnrichStore: FlightEnrichStore<FlightType, EnrichableProps>,
		api: Dap,
	) {
		super();

		makeObservable<
			FlightDetailStore<FlightType, EnrichableProps>,
			'_flight' | 'handleResponse'
		>(this, {
			_flight: observable,
			handleResponse: action,
			clear: action,
		});

		this.flightEnrichStore = flightEnrichStore;
		this.api = api;
	}

	public get flight() {
		if (!this._flight) {
			return undefined;
		}

		return this.flightEnrichStore.enrich([this._flight])[0];
	}

	protected async performRequest(
		params: IFlightFilterParams<FlightType>,
		options: IRequestOptions,
	) {
		this._params = params;
		return this.api.flights().get<FlightType>(params, options);
	}

	protected async handleResponse(response: IFlightsResponse<FlightType>) {
		const flights = response.data.flights.filter(
			(flight) =>
				flight.codeShareFlightNumber === this._params?.codeShareFlightNumber &&
				flight.scheduledDate === this._params?.scheduledDate &&
				flight.arrival === this._params?.arrival &&
				flight.arrivalAirport === this._params?.arrivalAirport &&
				flight.departureAirport === this._params?.departureAirport &&
				flight.viaAirport === this._params?.viaAirport,
		);
		const flight = flights[0];

		this._flight = flight;
	}

	public clear() {
		this._flight = undefined;
	}
}
